import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('angular-21');
  // IMPORTANT:
  // Injecting AuthService here ensures it is created
  // immediately on app load / page refresh
  private auth = inject(AuthService);
}
